<template>
  <div class="form-container">
    <h1>历史报名用户信息</h1>
    <el-table :data='tableShow'>
      <el-table-column prop='id' label='参会人ID' />
      <el-table-column prop='company' label='公司名' />
      <el-table-column prop='name' label='姓名' />
      <el-table-column prop='job' label='职位' />
      <el-table-column prop='mail' label='邮箱' />
      <el-table-column prop='phone' label='手机号' />
      <el-table-column prop='wechat' label='微信号' />
      <!-- <el-table-column prop='randomKey' label='校验码' /> -->
      <el-table-column prop='card' label='名片'>
        <template slot-scope='scope'>
          <el-popover ref="scope" width="500" trigger="hover" placement="left-start" offset=12>
            <img :src="scope.row.card" width="100%">
            <el-button slot="reference" type="text">
              <a :href="scope.row.card" target="_blank"> 查看名片</a>
            </el-button>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop='acid' label='报名场次' />
      <el-table-column prop='status' label='审核状态' :filters="[{ text: '待审核', value: '0' }, { text: '通过审核', value: '1' }, { text: '未通过审核', value: '2' }]"
        :filter-method="filterStatus">
        <template slot-scope='scope'>
          <span v-if='scope.row.status==0' class="need-pass">待审核</span>
          <span v-else-if="scope.row.status==1" class="need-passed">通过审核</span>
          <span v-else class="need-failed">未通过审核</span>
        </template>
      </el-table-column>

      <el-table-column label='审核操作'>
        <template slot-scope='scope'>
          <span v-if='scope.row.status == 0'>
            <el-button @click="passUser(scope.row.id,scope.row.acid)" type="text" size="small">通过</el-button>
            <el-button @click="rejectUser(scope.row.id,scope.row.acid)" type="text" size="small">拒绝</el-button>
          </span>

        </template>
      </el-table-column>
    </el-table>
    <!-- <div class="normal-pagination">
      <el-pagination layout="total, prev, pager, next" :page-size="50" :total="total" style="float:right" @current-change='changePage'>
      </el-pagination>
    </div> -->
  </div>
</template>

<script>
  export default {
    data() {
      return {
        tableShow: [],
        tableData: [],
        page: 1
      }
    },
    mounted() {
      this.getData()
    },
    methods: {
      getData() {
        this.$http.ac_user_list().then(res => {
          if (res.data.statusCode === 200) {
            this.tableShow = res.data.result
            // this.changePage(this.page)
          }
        })
      },
      editUser(id) {
        this.$router.push(`/meeting/users/${id}`)
      },
      filterStatus(value, row) {
        return row.status == value
      },
      passUser(id, acid) {
        this.$http.userReview('hkstocks', id, acid).then(res => {
          if (res.data.statusCode === 200) {
            this.getData()
          } else {
            this.$message({
              message: `(；へ：)!, ${res.data.message}`,
              type: 'warning',
              center: true
            })
          }
        })
      },
      rejectUser(id, acid) {
        this.$http.userReject("hkstocks", id, acid).then(res => {
          if (res.data.statusCode === 200) {
            this.getData()
          } else {
            this.$message({
              message: `(；へ：)!, ${res.data.message}`,
              type: 'warning',
              center: true
            })
          }
        })
      },
      changePage(id) {
        const start = (id - 1) * 50
        const end = start + 50
        this.page = id
        this.tableShow = this.tableData.slice(start, end)
      }
    },
    computed: {
      total() {
        return this.tableData.length
      }
    }
  }

</script>

<style scoped>
  .need-pass {
    color: #FA5555;
  }

  .need-passed {
    color: #67C23A
  }

  .need-failed {
    color: #878D99
  }

</style>



// WEBPACK FOOTER //
// src/components/backend/meetingusers.vue